import { subFilter } from '../types';

export const subFilterValue = (filter: subFilter[]) => filter?.map(({ value }: subFilter) => value);
